import CheckIcon from '@mui/icons-material/Pending';

export default function PendingApproval(){
    return (
        <div className='w-screen h-screen flex items-center justify-center bg-lightGrey'>
            <div className='bg-white rounded-md shadow-md flex flex-col p-5 w-[400px] items-center gap-1'>
                <CheckIcon style={{
                    fontSize: 50,
                    color: '#00ff00'
                }}>Filled</CheckIcon>
                <h2 className='text-xl font-bold text-black'>Pending for Approval</h2>
                <p className='text-xs font-bold text-center text-black'>We wil send you SMS when the action is completed.</p>
            </div>
        </div>
    )
}